import { gql } from '@apollo/client/core';
import ADVENTURES_LIST_FRAGMENT from '../adventures/fragments';

export const FETCH_APPLICATION_DETAILS_STATUS = gql`
  query ($application_uuid: UUID!) {
    applicationDetails(id: $application_uuid) {
      id
      parentInterestStatus
      job {
        isSharedJob
      }
    }
  }
`;

export const FETCH_JOB = gql`
  query ($job_uuid: UUID!, $first: Int, $parentInterestStatus: ParentInterestStatus) {
    job(id: $job_uuid) {
      id
      isSharedJob
      applications(first: $first, parentInterestStatus: $parentInterestStatus) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            parentInterestStatus
            sitter {
              id
              photoUrl
              displayName
              yearsExperience
              careTypeDetails {
                petCare {
                  name
                  yearsExperience
                  bio
                  maxPayRate
                }
                housekeeping {
                  name
                  yearsExperience
                  bio
                  maxPayRate
                  minPayRate
                }
                babysitter {
                  name
                  yearsExperience
                  bio
                  maxPayRate
                  minPayRate
                }
                companionCare {
                  name
                  yearsExperience
                  bio
                  maxPayRate
                }
                nanny {
                  name
                  bio
                  yearsExperience
                  minPayRate
                  maxPayRate
                }
              }
              location {
                cityname
                stateabbr
              }
              reviews {
                totalReviewCount
                starAggregate
              }
            }
          }
        }
      }
    }
  }
`;

export const FETCH_JOB_TOTALS = gql`
  query ($job_uuid: UUID!) {
    allStatusTotal: job(id: $job_uuid) {
      applications {
        totalCount
      }
    }
    receivedTotal: job(id: $job_uuid) {
      applications(parentInterestStatus: RECEIVED) {
        totalCount
      }
    }
    interestedTotal: job(id: $job_uuid) {
      applications(parentInterestStatus: INTERESTED) {
        totalCount
      }
    }
    notAFitTotal: job(id: $job_uuid) {
      applications(parentInterestStatus: NOT_A_FIT) {
        totalCount
      }
    }
  }
`;

export const FETCH_APPLICATION_DETAILS = gql`
  query ($application_uuid: UUID!, $reviewsFetchCount: Int) {
    applicationDetails(id: $application_uuid) {
      id
      createdAt
      distance
      reviewedApplicationText
      status
      parentInterestStatus
      memberCommunicationId
      parentInterestStatus
      parentLastRepliedAt
      matchingRequirements
      conversation {
        memberCommunicationId
        uuid
        id
      }
      job {
        title
        careType
        isSharedJob
        status
        isActive
      }
      sitter {
        id
        displayName
        firstName
        bio
        photoUrl
        yearsExperience
        careTypeDetails {
          petCare {
            name
            yearsExperience
            bio
            maxPayRate
          }
          housekeeping {
            name
            yearsExperience
            bio
            maxPayRate
            minPayRate
          }
          babysitter {
            name
            yearsExperience
            bio
            maxPayRate
            minPayRate
          }
          companionCare {
            name
            yearsExperience
            bio
            maxPayRate
          }
          nanny {
            name
            bio
            yearsExperience
            minPayRate
            maxPayRate
          }
        }
        state
        education {
          schoolName
          levelOfEducation
          yearGraduated
          major
          currentlyAttending
        }
        reviews(first: $reviewsFetchCount) {
          edges {
            node {
              id
              at
              reviewerShortName
              stars
              publicFeedback
            }
          }
          starAggregate
          totalReviewCount
        }
        idv {
          verdict
        }
        badges {
          name
          status
          expiresAt
          completedAt
        }
        location {
          cityname
          stateabbr
        }
        ...AdventuresList
      }
    }
  }
  ${ADVENTURES_LIST_FRAGMENT}
`;
